import React, { FC } from 'react';
import { Feature } from '../../types';

export interface FeatureTagProps {
  feature: Feature;
}

const FeatureTag: FC<FeatureTagProps> = ({ feature }) => {
  return (
    <span className="p-feature-tag">
      <picture className="p-feature-tag__picture">
        <img loading="lazy" className="p-feature-tag__image" src={feature.icon} alt={feature.name} />
      </picture>
    </span>
  );
};

export default FeatureTag;
